import Agric from "../assets/icons/leaf.svg";
import Arabic from "../assets/icons/arabic.svg";
import Art from "../assets/icons/art.svg";
import Biology from "../assets/icons/biology.svg";
import Chemistry from "../assets/icons/chemistry.svg";
import CRS from "../assets/icons/crs.svg";
import Commerce from "../assets/icons/commerce.svg";
import Computer from "../assets/icons/computer.svg";
import Economics from "../assets/icons/economics.svg";
import French from "../assets/icons/french.svg";
import Geography from "../assets/icons/geography.svg";
import Government from "../assets/icons/government.svg";
import hausa from "../assets/icons/hausa.svg";
import history from "../assets/icons/history.svg";
import homeEconomics from "../assets/icons/homeEconomics.svg";
import igbo from "../assets/icons/igbo.svg";
import islamic from "../assets/icons/islamic.svg";
import litInEng from "../assets/icons/litInEng.svg";
import maths from "../assets/icons/maths.svg";
import music from "../assets/icons/music.svg";
import physicalHealth from "../assets/icons/physicalHealth.svg";
import physics from "../assets/icons/physics.svg";
import accounting from "../assets/icons/accounting.svg";
import english from "../assets/icons/english.svg";
import yoruba from "../assets/icons/yoruba.svg";
import AgricPdf from "../assets/files/AgricPdf.pdf";
import ArabicPdf from "../assets/files/Arabic.pdf";
import ArtPdf from "../assets/files/Artpdf.pdf";
import BiologyPdf from "../assets/files/Biology.pdf";
import ChemistryPdf from "../assets/files/Chemistry.pdf";
import CRSPdf from "../assets/files/CRS.pdf";
import CommercePdf from "../assets/files/Commerce.pdf";
import ComputerPdf from "../assets/files/Computer.pdf";
import EconomicsPdf from "../assets/files/Economics.pdf";
import FrenchPdf from "../assets/files/French.pdf";
import GeographyPdf from "../assets/files/Geography.pdf";
import GovernmentPdf from "../assets/files/Government.pdf";
import HausaPdf from "../assets/files/Hausa.pdf";
import HistoryPdf from "../assets/files/History.pdf";
import homeEconomicsPdf from "../assets/files/Home-Economics.pdf";
import igboPdf from "../assets/files/Igbo.pdf";
import islamicPdf from "../assets/files/Islamic.pdf";
import litInEngPdf from "../assets/files/Literature.pdf";
import mathsPdf from "../assets/files/Mathematics.pdf";
import musicPdf from "../assets/files/Music.pdf";
import physicsPdf from "../assets/files/Physics.pdf";
import physicalHealthPdf from "../assets/files/PHE.pdf";
import accountingPdf from "../assets/files/Principles-of-Accounting.pdf";
import englishPdf from "../assets/files/Use-of-English.pdf";
import yorubaPdf from "../assets/files/Yoruba.pdf";

export const syllabus = [
  {
    id: 1,
    name: "Agriculture science",
    icon: Agric,
    alt: "Agric_icon",
    contentPdf: AgricPdf,
  },
  {
    id: 2,
    name: "Arabic",
    icon: Arabic,
    alt: "Arabic_icon",
    contentPdf: ArabicPdf,
  },
  {
    id: 3,
    name: "Art",
    icon: Art,
    alt: "Art_icon",
    contentPdf: ArtPdf,
  },
  {
    id: 4,
    name: "Biology",
    icon: Biology,
    alt: "Biology_icon",
    contentPdf: BiologyPdf,
  },
  {
    id: 5,
    name: "Chemistry",
    icon: Chemistry,
    alt: "Chemistry_icon",
    contentPdf: ChemistryPdf,
  },
  {
    id: 6,
    name: "Christian religious studies",
    icon: CRS,
    alt: "CRS_icon",
    contentPdf: CRSPdf,
  },
  {
    id: 7,
    name: "Commerce",
    icon: Commerce,
    alt: "Commerce_icon",
    contentPdf: CommercePdf,
  },
  {
    id: 8,
    name: "Computer studies",
    icon: Computer,
    alt: "computer_icon",
    contentPdf: ComputerPdf,
  },
  {
    id: 9,
    name: "Economics",
    icon: Economics,
    alt: "Economics_icon",
    contentPdf: EconomicsPdf,
  },
  {
    id: 10,
    name: "French",
    icon: French,
    alt: "French_icon",
    contentPdf: FrenchPdf,
  },
  {
    id: 11,
    name: "Geography",
    icon: Geography,
    alt: "Geography_icon",
    contentPdf: GeographyPdf,
  },
  {
    id: 12,
    name: "Government",
    icon: Government,
    alt: "Government_icon",
    contentPdf: GovernmentPdf,
  },
  {
    id: 13,
    name: "Hausa",
    icon: hausa,
    alt: "Hausa_icon",
    contentPdf: HausaPdf,
  },
  {
    id: 14,
    name: "History",
    icon: history,
    alt: "History_icon",
    contentPdf: HistoryPdf,
  },
  {
    id: 15,
    name: "Home-Economics",
    icon: homeEconomics,
    alt: "Home_Economics_icon",
    contentPdf: homeEconomicsPdf,
  },
  {
    id: 16,
    name: "Igbo",
    icon: igbo,
    alt: "Igbo_icon",
    contentPdf: igboPdf,
  },
  {
    id: 17,
    name: "Islamic-Studies",
    icon: islamic,
    alt: "Islamic_icon",
    contentPdf: islamicPdf,
  },
  {
    id: 18,
    name: "Literature-In-English",
    icon: litInEng,
    alt: "Lit_In_Eng_icon",
    contentPdf: litInEngPdf,
  },
  {
    id: 19,
    name: "Mathematics",
    icon: maths,
    alt: "Mathematics_icon",
    contentPdf: mathsPdf,
  },
  {
    id: 20,
    name: "Music",
    icon: music,
    alt: "Music_icon",
    contentPdf: musicPdf,
  },
  {
    id: 21,
    name: "Physics",
    icon: physics,
    alt: "Physics_icon",
    contentPdf: physicsPdf,
  },
  {
    id: 22,
    name: "Physical and Health Education",
    icon: physicalHealth,
    alt: "Phyical_Health_icon",
    contentPdf: physicalHealthPdf,
  },
  {
    id: 23,
    name: "Principles of Accounts",
    icon: accounting,
    alt: "Accounting_icon",
    contentPdf: accountingPdf,
  },
  {
    id: 24,
    name: "Use of English",
    icon: english,
    alt: "English_icon",
    contentPdf: englishPdf,
  },
  {
    id: 25,
    name: "Yoruba",
    icon: yoruba,
    alt: "Yoruba_icon",
    contentPdf: yorubaPdf,
  },
];
